export default __webpack_public_path__ + "images/489096c5c24ec175d564268cf669ece9.png";